import React, { useEffect, useState } from "react";
import { Button, ButtonGrey } from "../../../../style/Button";
import "./Bill.css";
import AdvertiserCard from "../../../common/card";
import { Checkbox } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
const PmsBilling = () => {
  const [value, setValue] = useState({});
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);  // Assuming check2, check3, and check4 are used elsewhere in the component
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    restoreView();
  }, [location.state]);

  const handleChange = (event) => {
    setCheck1(!check1);
    if (event.target.checked) {
      if (value) {
        const updatedValue = { ...value, discount: true };
        setValue(updatedValue);
        window.sessionStorage.setItem("med", JSON.stringify(updatedValue));
      }
    }
  };

  const restoreView = () => {
    if (location.state) {
      setValue(location.state);
      window.sessionStorage.setItem("med", JSON.stringify(location.state));
    } else {
      const storedValue = JSON.parse(window.sessionStorage.getItem("med"));
      if (storedValue) {
        setValue(storedValue);
      }
    }
  };

  const update = () => {
    history.push({
      pathname: "/People/Prescription",
    });
  };
  const pendingMedication = JSON.parse(window.sessionStorage.getItem("medication"))
  console.log("pendingMedication",pendingMedication)
  return (
    <>
      <div style={{ display: "flex" }}>
        <div style={{ width: "100%" }}>
          <section
            class="custom-radius border border-secondary customeFormBorder"
            style={{
              paddingBottom: "0px !important",
              backgroundColor: "white",
            }}
          >
            <nav
              class="navbar navbar-expand-lg border    navbar-primary bg-white "
              style={{ paddingTop: "18px", paddingBottom: "18px" }}
            >
              <a
                style={{
                  fontSize: "17px",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                }}
                class="navbar-brand  ms-4"
                // href="#"
              >
                {pendingMedication["medicationName"]}
              </a>
              <div
                class="collapse navbar-collapse"
                id="navbarNav"
                style={{ marginRight: "35px" }}
              >
                <ul
                  class="navbar-nav ms-auto "
                  style={{ fontSize: "12px", color: "#606060" }}
                >
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Type:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Brand Rx
                    </span>
                  </li>
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Formulary:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Un
                    </span>
                  </li>
                  <li
                    class="nav-item"
                    style={{
                      padding: 5,
                      fontWeight: 500,
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    }}
                  >
                    View Coverage
                  </li>
                </ul>
              </div>
            </nav>
            <nav
              class="navbar navbar-expand-lg border   navbar-primary bg-white "
              style={{ paddingTop: "5px", paddingBottom: "35px" }}
            >
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul
                  class="navbar-nav position-relative"
                  style={{ fontSize: "13px", right: "0px", textAlign: "right" }}
                >
                  <li class="nav-item " style={{ marginTop: "-9px" }}>
                    <div class="nav-link text-dark ">
                      <Checkbox
                        className="clickable2"
                        type="checkbox"
                      // onChange={this.handleChange}
                      />
                    </div>
                  </li>
                  <li class="nav-item ms-2">
                    <div
                      class="nav-link text-dark"
                      style={{
                        width: "32px",
                        height: "35px",
                        marginTop: "-3px",
                        fontSize: "20px",
                      }}
                    >
                      <i
                        class="far fa-money-bill-alt"
                        style={{ color: "#008576" }}
                      ></i>
                    </div>
                  </li>
                  <li class="nav-item ms-3">
                    <div
                      class="nav-link "
                      style={{
                        color: "#008576",
                        fontSize: "12px",
                        fontWeight: 500,
                        marginLeft: "7px",
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Coupon/Guide <br />
                      Available
                    </div>
                  </li>
                  {/* {this.state.check1 && (
                    <span
                      style={{ marginLeft: "-110%", marginTop: "30px" }}
                    ></span>
                  )} */}
                </ul>
              </div>
            </nav>
          </section>
        </div>
        {/* <div style={{ width: "25%" }}>
          <iframe
            style={{ height: "728px", width: "100%" }}
            srcDoc={verticalCreative}
          />
        </div> */}
      </div>
    </>
  );
}
export default PmsBilling
//Billing;
